import type { ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  hint?: string
  action?: ReactNode
}

export function EmptyState({ title, hint, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-sm border border-dashed border-ostrel-line px-6 py-10 text-center">
      <p className="text-sm font-medium text-ostrel-ink-muted">{title}</p>
      {hint && <p className="text-xs text-ostrel-ink-muted/70">{hint}</p>}
      {action}
    </div>
  )
}
